import { Translation } from "../types";

const translation: Translation = {
  login: "Logga in",
  register: "Registrera dig",
  loginWithEmail: "Har du fått en inbjudan? <0>Logga in med e-post</0>.",
  buyParkingPermit: "Köp parkeringstillstånd",
  manageVehicles: "Hantera fordon",
  wellbeingServicesCounty: "Norra Österbotten välfärdsområde",
  errors: {
    LimitExceededException: "För många försök. Försök igen senare.",
  },
  unknownError: "Ett oväntat fel inträffade. Försök igen senare.",
  navbar: {
    title: "Personalparkering",
    menuTooltip: "Öppna menyn",
    finnish: "Suomeksi",
    english: "In English",
    swedish: "På svenska",
    logout: "Logga ut",
    userDetails: "Användaruppgifter",
    drawer: {
      firstPage: "Försida",
      shop: "Butik",
      userInfo: "Användarinformation, fordon och tillstånd",
      helpdesk: "Helpdesk",
      faq: "Se frågor och svar",
      termsAndConditions: "Användarvillkor",
      privacyPolicy: "Integritetspolicy",
      contactInformation: "Kontaktinformation",
      paymentPolicy: "Betalningsvillkor",
    },
  },
  privacyPolicy: {
    title: undefined,
    paragraphs: undefined,
  },
  parkingMap: {
    title: "Parkeringsplatser och tillstånd",
    description: `Köpta personalparkeringstillstånd gäller inom alla välfärdsområden 
		på kontor, med undantag för KYS Puijo sjukhuscampus, som sköts av KYS parkering.`,
    listedLocations: "Se alla parkeringsplatser listade",
  },
  footer: {
    helpdesk: "Helpdesk",
    faq: "Se svaren på de <0>vanligaste frågorna</0>.",
  },
  home: {
    title: "Personalens tillståndsparkering webbutik",
    disclaimer: {
      p1: "Observera att endast e-postadresser som tillhör välfärdsområdet är tillåtna för inloggning.",
      p2: "Dessa är @pshyvinvointialue.fi, @servica.fi, @istekki.fi, @islab.fi, @sakupe.fi och @jstt.fi.",
    },
    flow: {
      login: {
        title: "Logga in",
        description:
          "Tillstånd för personalparkering kan endast köpas av inloggade användare från Pohde.",
      },
      buyParkingPermit: {
        title: "Köp parkeringstillstånd",
        description:
          "I webbutiken kan du enkelt köpa tillstånd som aktiveras när du gör din beställning.",
      },
      manageVehicles: {
        title: "Hantera fordon",
        description:
          "I tjänsten kan du hantera det fordon som är aktiverat för ditt tillstånd. Kom ihåg att hålla informationen uppdaterad!",
      },
    },
    webshop: {
      title: "Webbutik",
    },
  },
  loginForm: {
    title: "Logga in",
    email: "Ange e-postadress",
    password: "Ange lösenord",
    forgotPassword: "Glömt lösenord?",
    submit: "Logga in",
    authenticationError: "Felaktig e-postadress eller lösenord",
    tokenExpired: "Din session har löpt ut. Logga in igen.",
  },
  registerForm: {
    title: "Skapa ett konto",
    email: "Ange e-postadress",
    password: "Ange lösenord",
    confirmPassword: "Ange lösenord igen",
    invalidPassword:
      "Lösenordet måste vara minst 8 tecken långt och innehålla minst en siffra, en versal och ett specialtecken.",
    passwordMismatch: "Lösenorden matchar inte",
    userAlreadyExists:
      "Användaren finns redan. Om du hade parkeringstillstånd i det tidigare systemet eller har glömt ditt lösenord, <0>kan du återställa ditt lösenord här</0>.",
    userAlreadyExistsHelpText: "Användarnamnet finns redan",
    invalidEmail:
      "Observera att endast @pshyvinvointilue.fi, @servica.fi, @istekki.fi, @islab.fi, @sakupe.fi och @jstt.fi är tillåtna e-postadresser.",
    submit: "Skapa konto",
    acceptTerms: "Jag godkänner <0>avtalsvillkoren</0>*",
    acceptTermsRequired: "Vänligen acceptera villkoren för att fortsätta",
  },
  termsAndConditions: {
    title: "Sopimusehdot",
    heading: "POHJOIS-POHJANMAAN HYVINVOINTIALUEEN HENKILÖSTÖPYSÄKÖINTI",
    general: {
      subheading: "Yleistä tietoa",
      body: `
      Pohjois-Pohjanmaan hyvinvointialueen työntekijät voivat hankkia henkilöstöpysäköintiluvan oman työpisteensä 
      läheisyydestä. Joissakin kohteissa on rajattu määrä myytäviä pysäköintioikeuksia, joten osa alueista voidaan 
      myydä loppuun. Osassa verkkokaupan tuotteissa on rajaton määrä ostettavia pysäköintioikeuksia, mutta tarkempi 
      rajaus tehdään yksittäisellä kiinteistöllä. Esimerkiksi "kausimaksu" paikkoja on rajattomasti myynnissä, mutta 
      tarkemmat lämpöpaikkojen jakamiset tehdään kiinteistökohtaisesti.
      <br><br>
      Pysäköintioikeuden lunastaminen ei takaa paikan saatavuutta. On mahdollista, että kyseisellä alueella ei ole 
      paikkoja vapaana, vaikka olet lunastanut pysäköintioikeuden. Täysien paikkojen tapauksessa ei korvauksia tai 
      hyvityksiä anneta. Pysäköintimaksuja ei palauteta, jos työsuhde päättyy kesken maksetun kauden tai poissaolon, 
      kuten esimerkiksi sairasloman vuoksi. Sähkö- ja hybridiautojen lataaminen sekä sisätilanlämmittimen käyttö on 
      kielletty.`,
    },
    conditions: {
      subheading: "Sopimusehdot",
      parties: {
        subheading: "i. Sopijapuolet",
        body: `
				1. Pysäköintiluvan haltija<br>
				2. Finnpark Oy / Pohjois-Pohjanmaan hyvinvointialue
			`,
      },
      subject: {
        subheading: "ii. Sopimuksen kohde",
        body: `
				Tässä sopimuksessa määritellään pysäköintiluvan ehdot, käyttö ja voimassaoloaika. Pysäköintilupa viittaa 
				maksulliseen (sähköiseen/digitaaliseen) lupaan, jota käytetään henkilö- ja pakettiautoissa, ja joka antaa 
				oikeuden pysäköidä verkkokaupan tuotteen määrittelemälle alueelle, liikennemerkkien mukaisesti.
			`,
      },
      content: {
        subheading: "iii. Sopimuksen sisältö",
        body: `
				Pysäköintilupia myönnetään Pohjois-Pohjanmaan hyvinvointialueen ja sen konsernin henkilöstölle. Ajoneuvon 
				tulee olla liikennekäytössä ja sopijapuolen omistama, hallitsema tai muutoin pysyvästi tai pitkäaikaisesti 
				käytössä. Pysäköintilupa on henkilökohtainen ja sitä saa käyttää vain työhön tai työskentelyyn liittyvässä 
				pysäköinnissä. Lupaa ei saa lainata tai siirtää toiselle henkilölle.
			`,
      },
      terms: {
        subheading: "iv. Sopimuksen ehdot",
        body: `
				Ostettu pysäköintilupa ei takaa pysäköintipaikkaa, mikäli kaikki pysäköintipaikat ovat varattuna. Luvanhaltija 
				on velvollinen tarkastamaan luvan käyttöoikeuden pysäköintialueella. Pysäköintilupaa saa käyttää ainoastaan 
				liikennemerkkien mukaisella pysäköintialueella. Lupa ei oikeuta pysäköimään pysäköinninvalvonnasta annetun 
				lain vastaisesti.
				<br><br>
        Pohjois-Pohjanmaan hyvinvointialueella on oikeus muuttaa ja rajoittaa pysäköintiä tarpeen mukaan, esimerkiksi
        kunnossapidon vuoksi. Hyvinvointialue ei vastaa internetissä tai ohjekartoissa olevista virheellisistä 
        tiedoista. Hyvinvointialue pidättää oikeuden muuttaa pysäköintialueiden liikenne- ja pysäköintijärjestelyjä 
        tapahtumien tai muiden vastaavien syiden ajaksi. Hyvinvointialue voi tiedottaa pysäköintiluvan 
        haltijaa kunnossapito- ja muista töistä sopivalla tavalla. Työmaiden tai muiden syiden aiheuttamista 
        luvan käytön estymisistä tai haitoista ei makseta korvausta.
        <br><br>
        Työntekijän vastuulla on huolehtia pysäköintioikeuden irtisanomisesta, mikäli työsuhde päättyy. Maksut 
        suoritetaan toistuvina maksuina eli maksut eivät pääty automaattisesti, vaikka työsuhde päättyisikin. 
        Työntekijän tulee myös huolehtia, että toistuvaan maksuun valittu maksukortti on voimassa sekä huolehtia 
        maksukortin päivityksestä maksulle. Pohjois-Pohjanmaan hyvinvointialue ei palauta maksuja tai valvontamaksuja
        näissä tapauksissa.
		`,
      },
      otherTerms: {
        subheading: "v. Muut ehdot",
        body: `
				Sopimus tulee voimaan, kun lupamaksu on kokonaisuudessaan suoritettu. Lupa voidaan peruuttaa ilman 
				irtisanomisaikaa luvan väärinkäyttötilanteissa (esim. luovuttaminen toisen osapuolen käyttöön) eikä 
				sopijapuolella ole tällöin oikeutta lupamaksun palautukseen tai muuhun korvaukseen. Tämän sopimuksen 
				pätevyyttä, tulkintaa ja soveltamista koskevat mahdolliset ristiriidat, joista osapuolet eivät pääse 
				yksimielisyyteen neuvotteluin, ratkaistaan tarvittaessa riita- asiana Oulun käräjäoikeudessa.`,
      },
    },
    close: "Stäng",
  },
  confirmEmailForm: {
    title: "Bekräfta e-postadress",
    confirmationCode: "Ange bekräftelsekod",
    resendEmail: "Skicka igen",
    submit: "Bekräfta",
    confirmEmail:
      "En bekräftelsekod har skickats till din e-postadress. Ange den i fältet nedan.",
    confirmationCodeError: "Bekräftelsekoden är felaktig",
    confirmSuccess: "E-postadressen har bekräftats. Du kan nu logga in.",
    resendConfirmationCode: "Skicka verifieringskoden igen",
  },
  forgotPasswordForm: {
    title: "Glömt ditt lösenord?",
    confirmPasswordReset: "Ange bekräftelsekod och nytt lösenord",
    userNotFound: "Användaren hittades inte",
    submit: "Stäng in",
  },
  resetPasswordForm: {
    title: "Återställ lösenord",
    password: "Ange nytt lösenord",
    confirmPassword: "Ange nytt lösenord igen",
    resetPasswordSuccess: "Lösenordet har ändrats. Du kan nu logga in.",
  },
  userDetailsForm: {
    title: "Ange användaruppgifter",
    email: "E-post",
    firstName: "Förnamn",
    lastName: "Efternamn",
    editName: "Redigera namn",
    phoneNumber: "Telefonnummer",
    editPhoneNumber: "Redigera telefonnummer",
    changePassword: "Ändra lösenord",
    oldPassword: "Nuvarande lösenord",
    newPassword: "Nytt lösenord",
    confirmNewPassword: "Bekräfta nytt lösenord",
    passwordChangeSuccess: "Lösenordet har ändrats",
    wrongPasswordError: "Fel lösenord",

    submit: "Spara",
  },
  userDetailsPage: {
    title: "Användaruppgifter, tillstånd och fordon",
    purchaseParkingPermit: "Köp parkeringstillstånd",
    parkingPermits: {
      title: "Parkeringstillstånd",
      description:
        "Tänk på att endast ett fordon/registreringsnummer kan vara aktivt med tillståndet åt gången.",
      activeVehicle: "Fordon kopplat till tillståndet",
      noActiveVehicle: "Inget fordon kopplat till tillståndet",
      invalidActiveVehicle: "Fordonet finns inte i de listade fordonen",
      changeActiveVehicle: "Byt fordon",
      noParkingPermits: "Inga giltiga tillstånd.",
      cancelConfirmationTitle: "Avbryt prenumeration",
      cancelConfirmationText:
        "Är du säker på att du vill säga upp ditt parkeringstillståndsabonnemang? Du kan fortsätta att parkera under giltighetstiden för det tillstånd som du har betalat för.",
      cancelConfirmationTextPaidUntil:
        "Din licens är för närvarande giltig fram till {{ paid_until, string }}.",
      closeButton: "Fortsätt prenumerera",
      confirmButton: "Ja, avsluta prenumerationen",
      print: "Skriv ut",
      cancel: "Avbryt beställning",
      cancelError: "Fel inträffade, din prenumeration har inte avslutats",
    },
    paymentCard: {
      paymentMethod: "Betalningsmetod",
      expiryText: "Giltig {{month}}/{{year}}",
    },
  },
  vehiclesForm: {
    title: "Fordon",
    subtitle: "Du kan lägga till upp till tre fordon.",
    licensePlate: "Registreringsnummer",
    add: "Lägg till fordon",
    addInputLabel: "Ange registreringsnummer",
    addRequired: "Lägg till ett fordon för att köpa ett tillstånd",
    edit: "Redigera fordon {{ licensePlate, string }}",
    save: "Spara fordon",
    delete: "Ta bort fordon {{ licensePlate, string }}",
    chooseVehicle: "Välj fordon",
  },
  purchaseParkingPermit: {
    title: "Personalens tillståndsparkering webbutik",
    description:
      "Personalen kan köpa regionala tillstånd. Endast en registreringsskylt kan vara aktiv per tillstånd.",
    parkingPermitType: "Välj tillstånd för att köpa",
    productsQueryError:
      "Fel vid laddning av tillståndsprodukter, vänligen försök igen senare",
    validityStartDate: "Tillståndets giltighet börjar",
    parkingPermitDuration: undefined,
    parkingPermitDescription: {
      p1: "Ger rätt att parkera både på parkeringsplatser med och utan motorvärmaruttag.",
      p2: "Det köpta tillståndet är giltigt på välfärdsområdets alla verksamhetsställen med undantag för KYS:s parkeringshall på KYS Puijo sjukhusområde.",
    },
    validFromTitle: "Tillståndets giltighet börjar",
    validFrom: "Giltigt från:",
    validFromPurchase: "Köptid",
    validTo: "Giltigt till:",
    validDuration: "Gäller för:",
    validDurationDays: "{{ days }} dagar",
    paidUntil: "Förnyar",
    singlePaymentPrice: "Engångsbetalning:",
    submit: "Boka och betala",
    hasEnded: "Slutade",
    aboutToEnd: "På väg att avslutas",
    conflict: {
      title: "Ej tillgänglig för köp",
      content:
        "Tyvärr är alla tillstånd redan i bruk. Vänligen försök igen senare.",
    },
    successPage: {
      title: "Kassa",
      description: "Tack för att du beställt parkeringstillstånd",
      orderDetails: "Orderdetaljer",
      permitDetails: "Orderinformation",
      orderDate: "Orderdatum",
      orderNumber: "Ordernummer",
      totalPrice: "Totalpris",
      paymentMethod: "Betalningsmetod",
      invoicingAddress: "Faktureringsuppgifter",
      error: "Ett oväntat fel inträffade. Kontakta kundtjänst.",
    },
    cancelPage: {
      title: "Kassa",
      description: "Betalningen misslyckades",
      returnToShop: "Återgå till butiken",
      lede: "Ibland misslyckas betalningar med betalkort.",
      reasons: {
        preamble: "Orsakerna kan vara",
        causes: [
          "du avbröt köpet",
          "saldot på bankkontot kopplat till betalkortet var lägre än betalningen",
          "kreditkortets kreditgräns räckte inte till för betalningen",
          "anslutningsfel mellan betalningssystemet och banken som utfärdade kortet",
        ],
        postamble:
          "Kontrollera även att onlineköp är tillåtna på kortet. Kontakta din bank vid behov",
      },
    },
    recurrentBilling: "Pris för en återkommande prenumeration",
    recurrentBillingInfo:
      "Produkten har en återkommande betalningsfunktion, vilket innebär att betalningen automatiskt förnyas 30 dagar efter köpet om du inte säger upp prenumerationen innan dess.",
    singlePaymentInfo:
      "Produkten är en engångsbetalning och måste förnyas manuellt efter att tillståndet har löpt ut.",
    includesVat: "inkl. moms",
    dayAbrv: "dag",
    noProducts: "Du har inga produkter att köpa",
  },
  paymentPolicy: {
    title: "Betalningsförmedlare",
    paragraphs: [
      `Betalningsförmedlingstjänsten utförs och levereras av Paytrail Oyj (2122839-7) i samarbete 
		med banker och kreditinstitut. Paytrail Oyj syns som mottagare på bankkontot eller korträkningen 
		och förmedlar betalningen till köpmannen. Paytrail Oyj har verksamhetstillstånd för betalningsinstitut 
		beviljat av Finansinspektionen. Vid reklamation eller klagomål ber vi er i första hand vara i kontakt med tjänsteleverantören.`,
      "Paytrail Oyj",
      "FO-nummer: 2122839-7",
      "Innova 2",
      "Lutakonaukio 7",
      "40100 Jyväskylä",
    ],
    paytrailUrl: "https://paytrail.com/kuluttaja/information-om-betalning",
  },
  contactInfo: {
    title: "Kontaktinformation",
    webshop:
      "Norra Österbotten välfardsområde personalens tillståndsparkering webbutik",
    name: "Moovy Oy",
    noCustomerService: "Notera: Ingen kundtjänst",
    email: "e-post",
    emailContent: "support@pohde.zendesk.com",
    businessId: "FO-nummer",
    businessIdContent: "3375902-1",
    postAddress: "Postadress",
    postAddressContent: "PL 15",
    city: "33211 Tampere",
  },
  paymentCardChangeSuccess: {
    title: "Byt betalkort",
    success: "Framgång för förändring av betalkort",
    error: "Fel vid sparande av betalkort",
  },
  paymentCardChangeCancel: {
    title: "Byt betalkort",
    text: "Byte av betalkort har avbrutits. Det gamla betalkortet används fortfarande.",
  },
  requestSignIn: {
    title: "Logga in med e-post",
    email: "E-postadress",
    submit: "Skicka",
    success: "Länk för inloggning skickad! Kontrollera din e-post!",
  },
  tokenHandler: {
    info: "Du loggar in i webbshoppen för parkeringstillstånd med e-postadressen",
    error:
      "Din e-postinloggning misslyckades eller har löpt ut. Varje e-postregistreringslänk kan endast användas en gång och måste användas inom 10 minuter efter mottagandet",
    requestNewLink: "Begär ny länk <0>härifrån</0>",
    submit: "Fortsätta",
  },
  expiredEmailToken: {
    header: "Inloggningen har löpt ut",
    text: "Din inloggning via e-postlänken har löpt ut. Av säkerhetsskäl kan din e-postinloggning endast användas i 30 minuter. Du kan beställa en ny inloggningslänk <0>här</0>.",
  },
};

export default translation;
